import React from 'react';

// --- Début des Icônes SVG ---
// (remplacent lucide-react)

// Icône SVG pour "Insecte" (Bug)
const BugIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 20h-4a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-4Z"></path>
    <path d="M12 10V4a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v6"></path>
    <path d="m10 16 1.4-2.8"></path>
    <path d="m14 16-1.4-2.8"></path>
    <path d="M6 10H4"></path>
    <path d="M18 10h2"></path>
    <path d="M6 14H4"></path>
    <path d="M18 14h2"></path>
  </svg>
);

// Icône SVG pour "Spray"
const SprayCanIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m10 4 1.4-1.4a.5.5 0 0 1 .7 0L14 4"></path>
    <path d="M12 4v3"></path>
    <path d="M18 4h-2"></path>
    <path d="M6 4h2"></path>
    <path d="M12 7h.01"></path>
    <path d="M15 10v6a3 3 0 0 1-3 3h0a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h0a3 3 0 0 1 3 3Z"></path>
    <path d="M9 10v6"></path>
    <path d="M15 10v6"></path>
    <path d="M10 21h4"></path>
  </svg>
);

// Icône SVG pour "Bouclier Check"
const ShieldCheckIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="m9 12 2 2 4-4"></path>
  </svg>
);

// Icône SVG pour "Bouclier Alerte"
const ShieldAlertIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="M12 8v4"></path>
    <path d="M12 16h.01"></path>
  </svg>
);

// --- Fin des Icônes SVG ---

// J'ai rempli ce tableau avec les informations de votre image
// et les NOUVELLES icônes SVG
const services = [
  {
    icon: BugIcon, // Remplacé
    title: '1. Désinsectisation',
    description: 'Traitement contre les insectes rampants et volants : cafards, puces, fourmis, mouches, moustiques, punaises de lit...',
    features: ['Cafards & Puces', 'Mouches & Moustiques', 'Punaises de lit']
  },
  {
    icon: ShieldCheckIcon, // Remplacé
    title: '2. Dératisation',
    description: 'Élimination des rongeurs (rats, souris) avec pose de boîtes sécurisées.',
    features: ['Rats & Souris', 'Pose de boîtes sécurisées', 'Intervention garantie']
  },
  {
    icon: SprayCanIcon, // Remplacé
    title: '3. Désinfection',
    description: 'Traitement bactéricide et virucide des surfaces (cliniques, écoles, maisons, véhicules...).',
    features: ['Cliniques & Écoles', 'Maisons & Véhicules', 'Traitement bactéricide']
  },
  {
    icon: ShieldAlertIcon, // Remplacé
    title: '4. Traitement Anti-reptiles',
    description: 'Protection contre les serpents et autres nuisibles extérieurs.',
    features: ['Serpents', 'Nuisibles extérieurs', 'Protection périmétrique']
  }
];

export function ServicesSection() {
  return (
    <section id="services" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section - Mis à jour */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Nos Services Professionnels
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Solutions expertes pour l'élimination et la prévention des nuisibles,
            adaptées à vos besoins spécifiques.
          </p>
        </div>

        {/* Grille des services - Remplacé <Card> par <div> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon; // Ceci va maintenant être BugIcon, SprayCanIcon, etc.
            return (
              // Remplacé <Card> par <div>
              <div
                key={service.title}
                className="group hover:shadow-xl transition-all duration-300 border-0 bg-white hover:-translate-y-2 rounded-lg" // Ajout de rounded-lg
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Remplacé <CardContent> par <div> */}
                <div className="p-6 text-center">
                  {/* Icône */}
                  <div className="mb-4 flex justify-center">
                    <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                      <IconComponent className="w-8 h-8 text-primary" />
                    </div>
                  </div>

                  {/* Titre */}
                  <h3 className="text-xl font-semibold mb-3 text-foreground">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-muted-foreground mb-4 text-sm leading-relaxed" style={{ minHeight: '80px' }}> {/* Ajout d'une hauteur min pour l'alignement */}
                    {service.description}
                  </p>

                  {/* Caractéristiques (Exemples tirés de la description) */}
                  <ul className="space-y-2">
                    {service.features.map((feature) => (
                      <li key={feature} className="text-sm text-slate-blue font-medium flex items-center justify-center">
                        <div className="w-1.5 h-1.5 bg-primary rounded-full mr-2"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* Effet de survol */}
                  <div className="mt-6 opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent"></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA en bas de page - Remplacé par <button> */}
        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">
            Besoin d'une solution personnalisée ? Nous sommes là pour relever tous les défis.
          </p>
          <button
            className="text-primary hover:text-primary/80 font-semibold text-lg underline underline-offset-4 transition-colors"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Discutez de votre projet →
          </button>
        </div>
      </div>
    </section>
  );
}